import { connect } from "react-redux";
import { getBetsForTicket, getRaceEntrantsForBetsForTicket, getRacesForTicket } from "../selectors";
import ImportPicksBetList from "../components/import-picks-bet-list";

function select(state, props) {
  var { currentTicket } = props;

  var currentTicketId = currentTicket.get("id");

  var currentTicketProps = { ticketId: currentTicketId };

  return {
    bets: getBetsForTicket(state, props),
    currentTicketRaces: getRacesForTicket(state, currentTicketProps),
    races: getRacesForTicket(state, props),
    raceEntrants: getRaceEntrantsForBetsForTicket(state, props)
  };
}

export default connect(select)(ImportPicksBetList);
